<template>
  <el-dialog :title="title" :visible.sync="showAddQuestion" :close-on-click-modal="false" :before-close="handleClose">
    <div class="dialog-main-content">
      <!-- 查询条件 -->
      <div class="pat-search">
        <el-select v-model="type" size="small" @change="typeChange">
          <el-option v-if="$store.state.userPlatForm === 'platForm'" label="线下机构" value="hospitalNameLike">
          </el-option>
          <el-option label="医生团队" value="doctorTeamLike"></el-option>
          <el-option label="服务名称" value="serviceNameLike"></el-option>
          <el-option label="疗管链" value="therapistSchemeName"
            v-if="$store.state.userPlatForm === 'platForm'"></el-option>
        </el-select>
        <el-input v-model="listQuery[type]" clearable size="small" placeholder="请输入内容"></el-input>
        <el-button size="small" @click="resetForm">重置</el-button>
        <el-button type="primary" size="small" @click="handleSearch">搜索</el-button>
      </div>
      <div class="main-content-list">
        <el-table :data="tableData" style="width: 100%;"
          :header-cell-style="{ textAlign: 'center', color: '#333333', fontSize: '14px', fontWeight: 'bold', backgroundColor: '#FAFAFA' }">
          <el-table-column prop="hospitalName" label="线下机构" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="doctorTeamName" label="医生团队" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="doctorSchemeName" label="服务名称" align="center" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="period" label="服务周期" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="price" label="服务单价" align="center"></el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button v-if="!planPage" @click.native.prevent="assessmentSend(scope.$index, scope.row)" type="text"
                size="small">
                发送
              </el-button>
              <el-button v-else @click.native.prevent="chose(scope.$index, scope.row)" type="text" size="small">
                选择
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!-- 分页 -->
    <div slot="footer" style="text-align: right; margin-right: 30px">
      <el-pagination background :current-page="listQuery.current" :page-sizes="[10, 20, 30, 50]"
        :page-size="listQuery.size" layout="total, sizes, prev, pager, next, jumper" :total="total"
        @size-change="handleSizeChange" @current-change="handleCurrentChange" />
    </div>
  </el-dialog>
</template>
<script>
import {
  teamServicePage,
  teamServicePush,
  getAnswerSheetLog
} from "../../api/index";

export default {
  props: {
    showAddQuestion: {
      type: Boolean
    },
    title: {
      type: String
    },
    topHospitalId: {
      type: String,
    },
    param: {
      type: Object,
      default: {
        hospitalId: null
      }
    },
    planPage: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    showAddQuestion(val) {
      this.visible = val;
      if (val) {
        this.getInitData();
      }
    },
    param: {
      handle(val) {
      },
      deep: true
    }
  },
  data() {
    return {
      paperId: "",
      visible: false,
      questionnaireList: [],
      questionTypeList: [],
      name: "",
      region: [],
      listQuery: {
        doctorTeamLike: "", // 医生团队
        hospitalNameLike: "", // 线下机构
        serviceNameLike: "", // 服务名称
        therapistSchemeName: "",// 疗管链名称
        current: 1,
        size: 10
      },
      type: "",
      examTagList: [
        {
          label: "入案评估",
          value: 1
        },
        {
          label: "疾病评估量表",
          value: 2
        },
        {
          label: "疾病筛查量表",
          value: 3
        },
        {
          label: "生活方式评估",
          value: 4
        },
        {
          label: "功能评估",
          value: 5
        },
        {
          label: "患者服务评价",
          value: 6
        },
        {
          label: "心理评估",
          value: 7
        },
        {
          label: "生存质量评估",
          value: 8
        },
        {
          label: "随访问卷",
          value: 9
        }
      ],
      total: 0,
      tableData: [],
      typeFormData: {}
    };
  },
  async created() {
    this.type =
      this.$store.state.userPlatForm === "platForm"
        ? "hospitalNameLike"
        : "doctorTeamLike";
    await this.getInitData();
  },
  mounted() { },
  methods: {
    // async getQuestionData() {
    //   let { code, data } = await questionnaireDetails({
    //     id: this.paperId
    //   })
    //   if (code === 0) {
    //     this.quesData = data
    //   }
    // },
    typeChange(value) {
      this.listQuery = {
        doctorTeamLike: "", // 医生团队
        hospitalNameLike: "", // 线下机构
        serviceNameLike: "", // 服务名称
        therapistSchemeName: "",// 疗管链名称
        current: 1,
        size: 10
      };
    },
    // 重置
    resetForm() {
      Object.assign(this.listQuery, {
        doctorTeamLike: "",
        hospitalNameLike: "",
        serviceNameLike: "",
        therapistSchemeName: "",// 疗管链名称
        current: 1,
        size: 10
      });
    },
    handleClose() {
      this.$emit("update:showAddQuestion", false);
    },
    handleAdd(row) {
      this.$emit("receiveQuestion", row);
      this.$emit("update:showAddQuestion", false);
    },
    // 搜索
    async handleSearch() {
      Object.assign(this.listQuery, {
        ...this.listQuery,
        current: 1,
        size: 10
      });
      this.getInitData();
    },
    async getInitData() {
      // 分页等待
      let {
        code,
        data: { records, total }
      } = await teamServicePage({
        ...this.listQuery,
        topHospitalId: this.param.hospitalId ? this.param.hospitalId : null
      });
      if (code === 0) {
        this.tableData = records.map(item => {
          return {
            ...item,
            period: item.period + item.periodType,
            price: item.price + "元",
            doctorSchemeName: item.doctorScheme ? item.doctorScheme.name : item.name,
            hospitalName: item.hospitalName ? item.hospitalName : "-",
            doctorTeamName: !item.doctorTeamName || !item.doctorScheme ? "-" : item.doctorTeamName
          };
        });
        this.total = total;
      }
    },
    //选择
    chose(index, row) {
      row.emitType = '推荐服务';
      this.$emit('receiveParams', row);
      this.$emit("update:showAddQuestion", false);
    },
    handleSizeChange(val) {
      this.listQuery.size = val;
      this.listQuery.current = 1;
      this.getInitData();
    },
    handleCurrentChange(val) {
      this.listQuery.current = val;
      this.getInitData();
    },
    // 发送推荐服务
    async assessmentSend(index, row) {
      let { code, data } = await teamServicePush({
        groupCode: this.param.imId?.slice(5),
        patientId: this.param.patientId,
        serviceId: row.id,
        skipCheck: true
      });
      if (code === 0) {
        this.$message({
          type: "success",
          message: "服务推送成功"
        });
      }
      // 会发送一个卡片需要特殊配置
    }
  }
};
</script>
<style lang="less" scoped>
// .list-question-wrap {
//   // height: 100%;
// }

/deep/.el-dialog__body {
  padding-top: 0px;
}

.el-main {
  width: 100%;

  .main-content-list {
    height: 56vh;
    overflow: auto;
    padding-top: 15px;
    background-color: #fff;
  }
}

/deep/.el-pagination {
  text-align: right;
  margin-top: 15px;
  margin-right: 40px;
}

.btn-bg {
  background: #1a7bfc;
  color: #fff;
}

.dialog-main-content {
  .pat-search {
    display: flex;

    .el-input {
      margin-left: 10px;
    }
  }

  .el-button {
    margin-left: 10px;
  }
}

/deep/.el-table td {
  padding: 6px 0;
}
</style>
